"use client";

import { Accordion, AccordionItem, type Selection } from "@nextui-org/react";
 
import Image from "next/image"; 
import { useState } from "react";

function FrequenltyQuestionSection(props: {
  title: string,
  content: {
    key: string,
    title: string,
    content: string,
  }[]
}) { 
  const [selectedKeys, setSelectedKeys] = useState<Selection>();

  return (
    <section className="w-screen pb-[109px] flex items-center justify-center px-[40px]">
      <div
        className=" w-full max-w-[730px] flex flex-col items-start md:items-center
                    justify-center "
      >
        <p
          className=" font-degular-display-semibold text-[40px] md:text-[48px]
                      mb-[36px] md:mb-[80px]  md:text-center leading-none  "
        >
          {props.title}
        </p>
        <Accordion
          selectedKeys={selectedKeys}
          onSelectionChange={setSelectedKeys}
          className="px-0"
        >
          {
            props.content.map((item,) => (
              <AccordionItem
                key={item.key}
                aria-label={item.title}
                title={item.title}
                classNames={{
                  title:
                    "!text-black text-[24px] font-degular-display-semibold !py-0 ",
                  content: "!text-black",
                }}
                indicator={({ isOpen }) =>
                  isOpen ? (
                    <Image
                      alt="-"
                      src={"/assets/images/minus.svg"}
                      width={16}
                      height={16}
                      className=" rotate-90"
                    />
                  ) : (
                    <Image
                      alt="+"
                      src={"/assets/images/plus.svg"}
                      width={16}
                      height={16}
                    />
                  )
                }
              >
                {item.content}
              </AccordionItem>
            ))
          }
        </Accordion>
      </div>
    </section>
  );
}

export default FrequenltyQuestionSection;
